import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex no-wrap items-center justify-center gap-xs col"
}
const _hoisted_2 = { class: "fs-15px text-cool-gray-100" }
const _hoisted_3 = {
  key: 2,
  class: "flex no-wrap items-center justify-center gap-xs col"
}
const _hoisted_4 = { class: "fs-15px text-cool-gray-100" }

interface IComponentData {
  label: string
  value: boolean
}

interface IProps {
  left?: IComponentData
  right?: IComponentData
  paddingless?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogStateIndicator' },
  __name: 'BaseItemDialogStateIndicator',
  props: {
    left: { default: undefined },
    right: { default: undefined },
    paddingless: { type: Boolean, default: false }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseItemDialog__state-indicator rounded-16 row flex no-wrap items-center", { 'q-pa-md': !__props.paddingless }])
  }, [
    (_ctx.$slots['left'] || __props.left)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "left", {}, () => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.left?.label), 1),
            _createVNode(_component_k_icon, {
              name: __props.left?.value ? 'tick' : 'remove',
              color: __props.left?.value ? 'success-100' : 'error-70'
            }, null, 8, ["name", "color"])
          ])
        ]))
      : _createCommentVNode("", true),
    ((_ctx.$slots['left'] || __props.left?.label) && (_ctx.$slots['right'] || __props.right?.label))
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 1,
          vertical: "",
          size: "2px",
          color: "cool-gray-30"
        }))
      : _createCommentVNode("", true),
    (_ctx.$slots['right'] || __props.right)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "right", {}, () => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.right?.label), 1),
            _createVNode(_component_k_icon, {
              name: __props.right?.value ? 'tick' : 'remove',
              color: __props.right?.value ? 'success-100' : 'error-70'
            }, null, 8, ["name", "color"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})